import { render } from "./BaseUploadImage.vue?vue&type=template&id=78c8bf91"
import script from "./BaseUploadImage.vue?vue&type=script&lang=js"
export * from "./BaseUploadImage.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__